<template>
  <div>
    <BlogFeed/>
  </div>
</template>

<script>
import BlogFeed from '@/components/BlogFeed';

export default {
  name: 'Blog',
  data() {
    return {
    };
  },

  components: {
    BlogFeed,
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Blog.vue